module.exports = __webpack_public_path__ + "img/text.cc0f7bd7.png";